import { Form, Row, Col, Button } from 'react-bootstrap';
import { useState } from 'react';

export const DateAndTime = ({
	enableRemove = false,
	dateTime,
	id,
	commitChange,
	error,
	register,
	unregister,
	handleRemove = () => {},
}) => {
	const [currDateAndTime, setCurrDateAndTime] = useState(dateTime);
	function dateChange(target) {
		const { value } = target;
		currDateAndTime.date = value;
		setCurrDateAndTime(currDateAndTime);
		commitChange(currDateAndTime, id);
	}

	function timeChange(target) {
		const { value } = target;
		currDateAndTime.time = value;
		setCurrDateAndTime(currDateAndTime);
		commitChange(currDateAndTime, id);
	}

	return (
		<Row>
			<Col>
				<Form.Group>
					<Form.Label>Date of Display</Form.Label>
					<Form.Control
						value={currDateAndTime.date}
						type="date"
						onInput={dateChange}
						{...register(`dateAndTimes[${id}].date`)}
					/>
					<Form.Text className="text-danger">
						{error.dateAndTimes?.[id]?.date?.message}
					</Form.Text>
				</Form.Group>
			</Col>
			<Col>
				<Form.Group>
					<Form.Label>Time of Display</Form.Label>
					<Form.Control
						value={currDateAndTime.time}
						type="time"
						onInput={timeChange}
						{...register(`dateAndTimes[${id}].time`)}
					/>
					<Form.Text className="text-danger">
						{error.dateAndTimes?.[id]?.time?.message}
					</Form.Text>
				</Form.Group>
			</Col>
			{enableRemove === true && (
				<Col>
					<Button
						className="removeDateAndTimeBtn "
						variant="danger"
						onClick={() => {
							unregister(`dateAndTimes[${id}].date`);
							unregister(`dateAndTimes[${id}].time`);

							handleRemove(id);
						}}>
						Remove
					</Button>
				</Col>
			)}
		</Row>
	);
};
